import { render, staticRenderFns } from "./LancePackaging.vue?vue&type=template&id=21cbfe04&scoped=true&"
import script from "./LancePackaging.vue?vue&type=script&lang=js&"
export * from "./LancePackaging.vue?vue&type=script&lang=js&"
import style0 from "./LancePackaging.vue?vue&type=style&index=0&id=21cbfe04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cbfe04",
  null
  
)

export default component.exports